import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import RobotMascot from "./RobotMascot";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  ["how", "How it works"],
  ["bridge", "Micro advances"],
  ["products", "Loans"],
  ["faq", "FAQ"],
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (loc.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 450);
    } else {
      scrollToId(id);
    }
  };

  const goApply = () => {
    setOpen(false);
    navigate("/apply");
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || loc.pathname !== "/" ? "bg-white/70 backdrop-blur-xl border-b border-black/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => { setOpen(false); navigate("/"); }}
          className="flex items-center gap-2.5 group"
        >
          <span className="lr-float-slow"><RobotMascot className="w-9" /></span>
          <span className="font-display text-xl font-bold tracking-tight text-[#0A1628]">
            Lend<span className="text-[#007AFF]">Robot</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="text-sm font-medium text-[#52525B] hover:text-[#0A1628] transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-apply-btn"
            onClick={goApply}
            className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-[#0A1628] px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#007AFF] hover:shadow-[0_8px_24px_rgba(0,122,255,0.35)] hover:-translate-y-0.5"
          >
            Apply now <ArrowUpRight className="w-4 h-4" />
          </button>
          <button
            data-testid="nav-menu-toggle"
            className="md:hidden p-2 text-[#0A1628]"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-b border-black/5 px-5 py-4 flex flex-col gap-1">
          {LINKS.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-mobile-link-${id}`}
              onClick={() => go(id)}
              className="text-left py-3 text-base font-medium text-[#0A1628] border-b border-black/5"
            >
              {label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-apply-btn"
            onClick={goApply}
            className="mt-3 rounded-full bg-[#007AFF] px-5 py-3 text-sm font-semibold text-white"
          >
            Apply now
          </button>
        </div>
      )}
    </header>
  );
};

export default Nav;
